import React from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';
import css from './FaqPage.module.css';

const FaqPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  return (
    <StaticPage
      title="FAQ"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'FaqPage',
        description: 'FAQ',
        name: 'FAQ',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <h1 className={css.pageTitle}>Häufig gestellte Fragen (FAQs)</h1>

          <p>
            <strong className={css.question}>Wie funktioniert die Webseite unterkunft-kirchentag.de?</strong>
            <br />
            Um mehr darüber zu erfahren, wie die Webseite funktioniert,{' '}
            <a href="/how-it-works">klicke hier</a>, um den Bereich „Wie es funktioniert“ zu
            besuchen.
          </p>

          <p>
            <strong className={css.question}>Wie erstelle ich einen Eintrag?</strong>
            <br />
            Um einen neuen Eintrag zu erstellen, musst Du zunächst ein Benutzerkonto erstellen.
            Sobald Du dich angemeldet hast, musst Du nur die Schaltfläche „
            <a href="/l/draft/00000000-0000-0000-0000-000000000000/new/features">
              +Neuen Eintrag erstellen
            </a>
            “ in der oberen rechten Ecke oder im Menü der Website auswählen und kannst sofort mit
            der Erstellung Deines Eintrags für ein Unterkunftsgesuch oder Unterkunftsangebot
            beginnen.
          </p>

          <p>
            <strong className={css.question}>Ist es möglich, als Gruppe einen Sucheintrag zu erstellen? </strong>
            <br />
            Es ist natürlich möglich, einen Sucheintrag als Gruppe zu erstellen. Du kannst einfach
            ein neuen Eintrag erstellen im Eingabefeld „Beschreibung“ erläutern, mit wie vielen
            Leute ihr anreist und welche Personen aus eurer Gruppe gerne zusammen bleiben möchten.
            So können sich auch Gastgeber melden, die nur eine begrenzte Anzahl an Schlafplätzen
            verfügbar haben. Alternativ kannst Du natürlich auch mehrere Sucheinträge, d.h. einen
            separaten Sucheintrag für jede einzelne Untergruppe, erstellen. Das sollte eure
            Erfolgsaussichten auf eine schnelle Vermittlung noch einmal erhöhen.

          </p>

          <p>
            <strong className={css.question}>Wie markiere ich einen Eintrag als „reserviert“? </strong>
            <br />
            Bietest Du ein Privatquartier auf Unterkunft-Kirchentag an und hast einen Gast gefunden,
            musst Du den Eintrag nicht direkt offline nehmen. Stattdessen kannst Du Dein
            Privatquartier als reserviert markieren, bis die finale Zusage erfolgt ist. Eine
            entsprechende Status-Funktion, über die Du Deinen Eintrag als reserviert kennzeichnen
            könntest, gibt es nicht. Folge deshalb diesen Schritten, um einen Eintrag für andere
            Nutzer als reserviert zu markieren:
            <ol>
              <li>
                Rufe die Unterkunft-Kirchentag Webseite in Deinem Browser auf und melde Dich mit
                Deinen Benutzerdaten an.
              </li>
              <li>
                Klicke rechts oben auf Dein Profilfoto bzw. Deinen Avatar und anschließend auf
                „Deine Einträge“, um eine Übersicht Deiner Einträge aufzurufen.
              </li>

              <li>
                Suche in der Übersicht den Eintrag, den Du als reserviert markieren möchtest, und
                klicke auf die Option „Eintrag bearbeiten“.
              </li>

              <li>
                Gib nun im Eingabefeld „Titel“ am Anfang den Zusatz „reserviert“ ein, um den Eintrag
                zu kennzeichnen.
              </li>

              <li>
                Klicke abschließend auf „Beschreibung speichern“, damit die Änderungen übernommen
                werden.
              </li>
            </ol>
          </p>

          <p>
            <strong className={css.question}>Wie blende ich meinen Eintrag aus?</strong>
            <br />
            Wenn du eine Unterkunft oder eine:n Besucher:in gefunden hast, empfehlen wir, Deinen
            Eintrag auszublenden, sodass dieser nicht länger öffentlich angezeigt wird und andere
            Nutzer:innen sich nicht mehr auf das entsprechende Angebot/Gesuch melden. Um deinen
            Eintrag auszublenden, logge dich ein, besuche das Menü und wähle den Punkt „Meine
            Einträge“. Klicke nun auf dem Bild des Eintrags, den du ausblenden möchtest, oben
            rechts in der Ecke auf die Schaltfläche "Eintrag verwalten" und anschließend auf
            "Eintrag ausblenden".
          </p>

          <p>
            <strong className={css.question}>Mein:e Gastgeber:in/Besucher:in meldet sich nicht. Was soll ich machen?</strong>
            <br />
            Manche Gastgeber:innen oder Besucher:innen schauen vielleicht nicht regelmäßig in ihr
            Postfach oder bekommen viele Anfragen. Bitte hab etwas Geduld und schau parallel
            vielleicht aber auch nach weiteren Angeboten und kontaktiere diese.
          </p>

          <p>
            <strong className={css.question}>Du bekommst viele Anfragen?</strong>
            <br />
            Bitte melde dich doch trotzdem kurz bei den Menschen und informiere sie kurz. Zum
            Beispiel mit „Tut mir Leid, ich bekomme so viele Anfragen, ich muss die Anfragen erst
            sortieren und melde mich dann.“
          </p>

          <p>
            <strong className={css.question}>Du hast dich für jemanden entschieden?</strong>
            <br />
            Schön, dass ihr zusammengefunden habt! Bitte vergiss dabei aber nicht, deinen anderen
            Anfragen abzusagen. Das hilft den Anfragenden, sich auf andere Angebote zu
            konzentrieren.
          </p>

          <p>
            <strong className={css.question}>Du bekommst eine Anfrage, die du nicht annehmen möchtest?</strong>
            <br />
            Das kann auf beiden Seiten vorkommen und ist auch kein Problem. Vielleicht ist aber ein
            persönliches Gespräch hilfreich und kann mehr Aufschluss über die Person geben als nur
            das Profil. Wenn dein Eindruck sich bestätigt, melde dich trotzdem gerne bei der Person
            und sage ab.
          </p>

          <p>
            <strong className={css.question}>
              Wo finde ich Informationen zu den Themen: Camping, Gemeinschaftsquartiere oder
              Hotels/Pensionen?
            </strong>
            <br />
            Für Informationen und Kontaktstellen zu den Themen: Camping, Gemeinschaftsquartiere oder
            Hotels/Pensionen,{' '}
            <a href="https://www.kirchentag.de/unterkunft" target="_blank">
              klicke hier.
            </a>
          </p>

          <p>
            <strong className={css.question}>Kostet die Erstellung eines Eintrags etwas?</strong>
            <br />
            Die Erstellung von Einträgen und die Benutzung der Webseite Unterkunft-Kirchentag ist
            kostenfrei.
          </p>


          {/* <p>
            <strong className={css.question}>How does Kirchentag work?</strong><br/>
            To learn how Kirchentag works, please <a href='/how-it-works'>click here</a> to check out our page “Wie es funktioniert”. 
          </p>

          <p>
            <strong className={css.question}>How do I create a listing?</strong><br/>
            To create a new listing, you first need to set up an account. Once you’re signed up, you just need to select the button „+create new listing“ in the upper right corner or menu of the website and you can start creating your listing right away.
          </p>
           

           <p>
             <strong className={css.question}>How do I close my listing?</strong><br/>
             If you have found a helper or refugee and no longer want your listing to be shown to the public, you need to go to the menu and select “my listings”. Click the button “close listing” in the top right corner of the image of the listing, that you want to close.
              <br/>  <br/>
              If you later on want to re-open the listing, you can always do so by clicking on the button “open listing” in the “my listings” section.
           </p>

           <p>
             <strong className={css.question}>What does the blue „verified“ symbol stand for?</strong><br/>
             The blue “verified” symbol indicates, that the person or organization behind the user account verified their identity. In case of an organization, the verification happens by collecting certain official documentation. In case of a private user, this happens through the verification procedure of our partner “Veriff”, which is one of the world’s leading online verification providers and works closely together with multinational corporations such as banks or insurances from all around the world. 
             <br/>  <br/>
             During the verification process, users upload a live-selfie-photo as well as images of their identity document (e.g. passport, ID card, driver’s license), which will then be verified. The process takes less then 2 minutes. 
              <br/>
              The verified label does not guarantee the legitimacy of the listing. Everyone is still responsible for his own safety. Hence, we encourage everyone to take his own precautions. 
           </p>

           <p>
             <strong className={css.question}>Why do I have to verify my identity?</strong><br/>
             By verifying your identity, you contribute to ensure a safer platform for both refugees and helpers. Furthermore, it adds trustworthiness to your account and increases the chances to find a match.
             <br/>  <br/>
             We recommend you to verify your identity through our verification partner “Veriff”. This will increase the trustworthiness of your user profile and the chances that helpers/refugees reach out to you. Furthermore, we recommend to primarily accept help from verified users. You can recognize a verified user profile by the blue “verified” label next to the respective username. Being in contact with a user, who is not verified, we recommend to ask him to verify himself. It takes under 2 minutes and only requires a live-photo and an official document (e.g. passport, ID card, driver’s license). To start the verification process, you can go to your user profile settings and click on the button “Validate your identity”.
           </p>

           <p>
             <strong className={css.question}>How do I verify myself?</strong><br/>
             To verify yourself, you need to log in to your Kirchentag account, select the profile settings and click on „validate my identity“. In case of an organization, you are asked to provide us with certain official documentation. In case of a private account, you’ll have to fill in your name. Subsequently, a pop-up window opens, which leads you through the verification process. 
           </p> */}
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default FaqPage;
